import { CustomModal } from "components";
import { useEffect, useState, memo, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Button } from "reactstrap";
import { useCheckValid, MultipleTitleMapper, renderPage, initialAddAttendanceModalFormState, additionalCommentsQuestions } from "./constants";
import { addTimes, transformDate } from "utils/dateHelper";
import apiService from "services/api";
import { useMutation } from "react-query";
import { useNotificationContext } from "contexts";
import { useQueryClient, useQuery } from "react-query";
import moment from "moment";

const AddStudentReportPage = ({ open, hide, lessonDetail, submitCallback = () => {} }) => {
	const queryClient = useQueryClient();
	const { createNotification } = useNotificationContext();
	const {
		handleSubmit,
		formState: { errors },
		setValue,
		reset,
		trigger,
		watch,
		control,
		getValues,
		register,
	} = useForm({
		defaultValues: initialAddAttendanceModalFormState,
	});

	const { data: studentTraits, isLoading: loadingStudentTraits } = useQuery("studentTraits", () => apiService.student.traits.get());

	const submitReport = useMutation(
		(data) =>
			apiService.lessonRecord.addReport(lessonDetail?.id, data).then((response) => {
				createNotification({
					type: "success",
					message: "Lesson report submitted",
				});
				resetHandler(response);
				submitCallback();
				queryClient.invalidateQueries("lessonRecord");
			}),
		{}
	);
	const [page, setPage] = useState(0);
	const [studentPrefix, setStudentPrefix] = useState(0);

	const checkValid = useCheckValid(trigger);

	useEffect(() => {
		if (open) {
			setValue(
				"preparationStartTime",
				transformDate({
					unit: "hour",
					value: -1,
					time: lessonDetail?.startTime,
				})
			);
			setValue("preparationEndTime", lessonDetail?.startTime);
			setValue("reportStartTime", lessonDetail?.endTime);
			setValue("reportEndTime", moment(lessonDetail.endTime, "HH:mm:ss").add("minutes", 30).format("HH:mm:ss"));
			setValue("startTime", lessonDetail?.startTime);
			setValue("endTime", lessonDetail?.endTime);
			setValue(
				"studentReport",
				lessonDetail?.students?.map((student) => ({
					studentId: student.studentDetail.id,
					traits: studentTraits,
					learningObjectives: lessonDetail?.lesson?.learningObjectives,
					additionalComments: additionalCommentsQuestions.map((additionalComment) => ({
						question: additionalComment.question,
					})),
				}))
			);
			if (lessonDetail?.lesson) setValue("customLessonName", lessonDetail?.lesson?.name);
			setValue("isCustomLesson", lessonDetail?.isCustomLesson || Boolean(lessonDetail?.lesson?.isCustomLesson));
			if (lessonDetail?.course) setValue("courseName", lessonDetail?.course?.name);
		}
	}, [open, studentTraits, lessonDetail]);

	const addAttendance = (data) => {
		const formBody = {
			...data,
			lessonDetail,
			lessonDetailId: lessonDetail?.id,
		};
		submitReport.mutate(formBody);
	};

	const nextPage = async (e) => {
		e.preventDefault();
		console.log(page);
		if (!(await checkValid(page, studentPrefix))) return;
		setPage((curr) => curr + 1);
	};

	const prevPage = () => setPage((curr) => curr - 1);

	const resetHandler = (data = undefined) => {
		// submitCallback();
		if (data) reset(data);
		else reset();
		hide();
		setPage(0);
	};

	const pages = renderPage({
		students: lessonDetail?.students,
		control,
		watch,
		register,
		errors,
		lessonDetail,
		studentTraits,
		setStudentPrefix,
		getValues,
		setValue,
	});

	return (
		<form onSubmit={handleSubmit(addAttendance)}>
			<CustomModal
				show={open}
				hideModal={() => {
					// resetHandler();
					hide();
				}}
				light={true}
				title={MultipleTitleMapper(lessonDetail?.students)[page]}
				triggerAlertWhenClose={true}
				triggerAlertMessageWhenClose="Leave tab? All details entered will be gone."
				buttons={
					<>
						{page > 0 && (
							<Button color="secondary" onClick={prevPage}>
								Back
							</Button>
						)}
						{page === 2 + lessonDetail?.students?.length * 4 ? (
							<Button color="success" type="submit" disabled={submitReport.isLoading}>
								Submit
							</Button>
						) : (
							<Button color="primary" onClick={nextPage} type="button">
								Next
							</Button>
						)}
					</>
				}
			>
				{pages[page]}
			</CustomModal>
		</form>
	);
};

export { AddStudentReportPage };
